// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1sxWC","productName":"Table_productName__3VxPN"};